/* BASIC APP CONSTANTS */
export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const APP_COOKIE_NAME = "APP_COOKIE_NAME";
export const USER_COOKIE_NAME = "USER_COOKIE_NAME";
export const PASS_COOKIE_NAME = "PASS_COOKIE_NAME";
export const USER_ID_COOKIE_NAME = "USER_ID_COOKIE_NAME";
export const SET_CURRENT_ROUTE = "SET_CURRENT_ROUTE";
export const SET_SIDE_MENU_STATE = "SET_SIDE_MENU_STATE";
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const CLOSE_NOTIFICATION = "CLOSE_NOTIFICATION";
export const SHOW_ACTION_MENU = "SHOW_ACTION_MENU";
export const HIDE_ACTION_MENU = "HIDE_ACTION_MENU";
export const SHOW_BOTTOM_TOOLBAR = "SHOW_BOTTOM_TOOLBAR";
export const HIDE_BOTTOM_TOOLBAR = "HIDE_BOTTOM_TOOLBAR";
export const SET_USER_LIST = "SET_USER_LIST";
export const EDIT_DISABLED_BUTTONS = "EDIT_DISABLED_BUTTONS";
export const SET_LOGS_LIST = "SET_LOGS_LIST";
export const THEME = "THEME";

/* <---- BASIC APP CONSTANTS ----> */

/* SOCKET CONSTANTS */
export const CONNECTED = "connected";
export const DISCONNECTED = "disconnected";
/* <---- SOCKET CONSTANTS ----> */

/* CONFIGURATION */
export const CONFIGURATION_FORM_TOOGLE_LOADING =
  "CONFIGURATION_FORM_TOOGLE_LOADING";
export const SET_CONFIGURATION = "SET_CONFIGURATION";
/* <---- CONFIGURATION ----> */

/* USER */
export const SET_PROFILE = "SET_PROFILE";
/* <---- USER ----> */

/* USERS */
export const ADD_NEW_USER = "ADD_NEW_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
export const OPEN_USER_FORM = "OPEN_USER_FORM";
export const CLOSE_USER_FORM = "CLOSE_USER_FORM";
export const EDIT_SELECTED_USER = "EDIT_SELECTED_USER";
export const USERS_FORM_TOOGLE_LOADING = "USERS_FORM_TOOGLE_LOADING";
/* <---- USERS ----> */

/* SUPPORT */
export const SET_SUPPORT_LIST = "SET_SUPPORT_LIST";
export const ADD_NEW_SUPPORT = "ADD_NEW_SUPPORT";
export const UPDATE_SUPPORT = "UPDATE_SUPPORT";
export const DELETE_SUPPORT = "DELETE_SUPPORT";
export const OPEN_SUPPORT_FORM = "OPEN_SUPPORT_FORM";
export const CLOSE_SUPPORT_FORM = "CLOSE_SUPPORT_FORM";
export const EDIT_SELECTED_SUPPORT = "EDIT_SELECTED_SUPPORT";
export const SUPPORT_FORM_TOOGLE_LOADING = "SUPPORT_FORM_TOOGLE_LOADING";
/* <---- SUPPORT ----> */

/* ZONECATEGORY */
export const SET_ZONECATEGORY_LIST = "SET_ZONECATEGORY_LIST";
export const ADD_NEW_ZONECATEGORY = "ADD_NEW_ZONECATEGORY";
export const UPDATE_ZONECATEGORY = "UPDATE_ZONECATEGORY";
export const DELETE_ZONECATEGORY = "DELETE_ZONECATEGORY";
export const OPEN_ZONECATEGORY_FORM = "OPEN_ZONECATEGORY_FORM";
export const CLOSE_ZONECATEGORY_FORM = "CLOSE_ZONECATEGORY_FORM";
export const EDIT_SELECTED_ZONECATEGORY = "EDIT_SELECTED_ZONECATEGORY";
export const ZONECATEGORY_FORM_TOGGLE_LOADING = "ZONECATEGORY_FORM_TOGGLE_LOADING";
/* <---- ZONECATEGORY ----> */

/* ROLE */
export const SET_ROLE_LIST = "SET_ROLE_LIST";
export const ADD_NEW_ROLE = "ADD_NEW_ROLE";
export const UPDATE_ROLE = "UPDATE_ROLE";
export const DELETE_ROLE = "DELETE_ROLE";
export const OPEN_ROLE_FORM = "OPEN_ROLE_FORM";
export const CLOSE_ROLE_FORM = "CLOSE_ROLE_FORM";
export const EDIT_SELECTED_ROLE = "EDIT_SELECTED_ROLE";
export const ROLE_FORM_TOGGLE_LOADING = "ROLE_FORM_TOGGLE_LOADING";
/* <---- ROLE ----> */

/* WASTETYPE */
export const SET_WASTETYPE_LIST = "SET_WASTETYPE_LIST";
export const ADD_NEW_WASTETYPE = "ADD_NEW_WASTETYPE";
export const UPDATE_WASTETYPE = "UPDATE_WASTETYPE";
export const DELETE_WASTETYPE = "DELETE_WASTETYPE";
export const OPEN_WASTETYPE_FORM = "OPEN_WASTETYPE_FORM";
export const CLOSE_WASTETYPE_FORM = "CLOSE_WASTETYPE_FORM";
export const EDIT_SELECTED_WASTETYPE = "EDIT_SELECTED_WASTETYPE";
export const WASTETYPE_FORM_TOOGLE_LOADING = "WASTETYPE_FORM_TOOGLE_LOADING";
/* <---- WASTETYPE ----> */

/* ESTABLISHMENT */
export const SET_ESTABLISHMENT_LIST = "SET_ESTABLISHMENT_LIST";
export const ADD_NEW_ESTABLISHMENT = "ADD_NEW_ESTABLISHMENT";
export const UPDATE_ESTABLISHMENT = "UPDATE_ESTABLISHMENT";
export const DELETE_ESTABLISHMENT = "DELETE_ESTABLISHMENT";
export const OPEN_ESTABLISHMENT_FORM = "OPEN_ESTABLISHMENT_FORM";
export const CLOSE_ESTABLISHMENT_FORM = "CLOSE_ESTABLISHMENT_FORM";
export const EDIT_SELECTED_ESTABLISHMENT = "EDIT_SELECTED_ESTABLISHMENT";
export const ESTABLISHMENT_FORM_TOOGLE_LOADING = "ESTABLISHMENT_FORM_TOOGLE_LOADING";
/* <---- ESTABLISHMENT ----> */

/* HOTELCHAIN */
export const SET_HOTELCHAIN_LIST = "SET_HOTELCHAIN_LIST";
export const ADD_NEW_HOTELCHAIN = "ADD_NEW_HOTELCHAIN";
export const UPDATE_HOTELCHAIN = "UPDATE_HOTELCHAIN";
export const DELETE_HOTELCHAIN = "DELETE_HOTELCHAIN";
export const OPEN_HOTELCHAIN_FORM = "OPEN_HOTELCHAIN_FORM";
export const CLOSE_HOTELCHAIN_FORM = "CLOSE_HOTELCHAIN_FORM";
export const EDIT_SELECTED_HOTELCHAIN = "EDIT_SELECTED_HOTELCHAIN";
export const HOTELCHAIN_FORM_TOOGLE_LOADING = "HOTELCHAIN_FORM_TOOGLE_LOADING";
/* <---- HOTELCHAIN ----> */

/* CONTAINERMEASUREMENT */
export const SET_CONTAINERMEASUREMENT_LIST = "SET_CONTAINERMEASUREMENT_LIST";
export const ADD_NEW_CONTAINERMEASUREMENT = "ADD_NEW_CONTAINERMEASUREMENT";
export const UPDATE_CONTAINERMEASUREMENT = "UPDATE_CONTAINERMEASUREMENT";
export const DELETE_CONTAINERMEASUREMENT = "DELETE_CONTAINERMEASUREMENT";
export const OPEN_CONTAINERMEASUREMENT_FORM = "OPEN_CONTAINERMEASUREMENT_FORM";
export const CLOSE_CONTAINERMEASUREMENT_FORM = "CLOSE_CONTAINERMEASUREMENT_FORM";
export const EDIT_SELECTED_CONTAINERMEASUREMENT = "EDIT_SELECTED_CONTAINERMEASUREMENT";
export const CONTAINERMEASUREMENT_FORM_TOOGLE_LOADING = "CONTAINERMEASUREMENT_FORM_TOOGLE_LOADING";
/* <---- CONTAINERMEASUREMENT ----> */

/* HOTELDATA */
export const SET_HOTELDATA_LIST = "SET_HOTELDATA_LIST";
export const ADD_NEW_HOTELDATA = "ADD_NEW_HOTELDATA";
export const UPDATE_HOTELDATA = "UPDATE_HOTELDATA";
export const DELETE_HOTELDATA = "DELETE_HOTELDATA";
export const OPEN_HOTELDATA_FORM = "OPEN_HOTELDATA_FORM";
export const CLOSE_HOTELDATA_FORM = "CLOSE_HOTELDATA_FORM";
export const EDIT_SELECTED_HOTELDATA = "EDIT_SELECTED_HOTELDATA";
export const HOTELDATA_FORM_TOGGLE_LOADING = "HOTELDATA_FORM_TOGGLE_LOADING";
/* <---- HOTELDATA ----> */

/* CONTAINER */
export const SET_CONTAINER_LIST = "SET_CONTAINER_LIST";
export const ADD_NEW_CONTAINER = "ADD_NEW_CONTAINER";
export const UPDATE_CONTAINER = "UPDATE_CONTAINER";
export const DELETE_CONTAINER = "DELETE_CONTAINER";
export const OPEN_CONTAINER_FORM = "OPEN_CONTAINER_FORM";
export const CLOSE_CONTAINER_FORM = "CLOSE_CONTAINER_FORM";
export const EDIT_SELECTED_CONTAINER = "EDIT_SELECTED_CONTAINER";
export const CONTAINER_FORM_TOOGLE_LOADING = "CONTAINER_FORM_TOOGLE_LOADING";
/* <---- CONTAINER ----> */

/* ZONE */
export const SET_ZONE_LIST = "SET_ZONE_LIST";
export const ADD_NEW_ZONE = "ADD_NEW_ZONE";
export const UPDATE_ZONE = "UPDATE_ZONE";
export const DELETE_ZONE = "DELETE_ZONE";
export const OPEN_ZONE_FORM = "OPEN_ZONE_FORM";
export const CLOSE_ZONE_FORM = "CLOSE_ZONE_FORM";
export const EDIT_SELECTED_ZONE = "EDIT_SELECTED_ZONE";
export const ZONE_FORM_TOOGLE_LOADING = "ZONE_FORM_TOOGLE_LOADING";
/* <---- ZONE ----> */

/* ROUTES */
export const SET_ALL_ROUTES = "SET_ALL_ROUTES";
export const UPDATE_ROUTE = "UPDATE_ROUTE";
/* <---- ROUTES ----> */

/* ALERT */
export const SET_ALERT_LIST = "SET_ALERT_LIST";
export const ADD_NEW_ALERT = "ADD_NEW_ALERT";
export const UPDATE_ALERT = "UPDATE_ALERT";
export const DELETE_ALERT = "DELETE_ALERT";
export const OPEN_ALERT_FORM = "OPEN_ALERT_FORM";
export const CLOSE_ALERT_FORM = "CLOSE_ALERT_FORM";
export const EDIT_SELECTED_ALERT = "EDIT_SELECTED_ALERT";
export const ALERT_FORM_TOOGLE_LOADING = "ALERT_FORM_TOOGLE_LOADING";
/* <---- ALERT ----> */
